import React, { useRef, useState, useEffect } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import Shop from '../../assets/icons/shop-card.svg';
import { imgBaseUrl ,getBasketList,setCountBasketList, deleteFromBasket} from '../../utils/api';
import FastLoginCom from '../../components/fastLogin/fastLogin'
import { Badge } from 'primereact/badge';
import { useCart } from '../../contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import useToastNotification from '../../hooks/useToastNotification';


const Basket = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [fastLogin, setFatsLogin] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);
    const [items, setItems] = useState([]);
    const [totalItems, setTotalItems] = useState('');
    const { cartItems } = useCart();
    const { basketList } = useCart();
    const { addToCart } = useCart();
    const { showError, showSuccess } = useToastNotification();

    useEffect(() => {
        // setItems(cartItems);
        setTotalItems(cartItems); // تعداد انواع محصولات

    }, [cartItems]);

    const openBasket = async (event) => {
        let clientId = localStorage.getItem('clientId')
        try {
            let res = await getBasketList(clientId)
            if (res.data.isSuccess) {
                setItems(res.data.data)
            }
        } catch (error) {

        }
        setShow(!show);
        setTarget(event.target);
    };

    const closeBasket = () => {
        setShow(false);
    };
    const changeCountProduct = async (updatedQuantity, product) => {
        try {
            let pay = {
                clientId: localStorage.getItem('clientId'),
                basketId: product.basketId,
                count: updatedQuantity
            };
            console.log(pay);
            let res = await setCountBasketList(pay);
            
            if (!res.data.isSuccess) {
                showError(res.data.message)
                return false;
                // بعد از موفقیت‌آمیز بودن تغییر، لیست را مجدداً از سرور دریافت کنید
                // let updatedBasket = await getBasketList(localStorage.getItem('clientId'));
                // if (updatedBasket.data.isSuccess) {
                //     setItems(updatedBasket.data.data);
                // }
            }
        } catch (error) {
            console.error("Error updating product count:", error);
            return false;
        }

        return true;
    };
    
    const changeQuantity = async (item, action) => {
        console.log(item)
         if (item.productId) {
        // ابتدا مقدار جدید را محاسبه کنید
            const updatedCount = action === 'add' ? item.count + 1 : item.count - 1;
            
            if (updatedCount > 0) {
                // عملیات async را انجام دهید
                const res = await changeCountProduct(updatedCount, item);
                
                if (res) {
                    // اگر موفق بود، state را آپدیت کنید
                    setItems(oldItems =>
                        oldItems.map(oldItem => 
                            oldItem.basketId === item.basketId 
                                ? { ...oldItem, count: updatedCount }
                                : oldItem
                        )
                    );
                }
            } else {
                // اگر تعداد صفر شد، آیتم را حذف کنید
                removeFromCart(item);
            }
        }
        else {
            setItems(oldItems =>
                oldItems.map(oldItem => {
                    if (oldItem.productId === item.productId) {
                        const updatedCount = action === 'add' ? oldItem.count + 1 : oldItem.count - 1;

                        if (updatedCount > 0) {
                            saveToLocalStorage(oldItem.productId, updatedCount);
                            return { ...oldItem, count: updatedCount };
                        } else {
                            removeFromCart(oldItem.productId); // Remove item if count reaches 0
                            // addToCart()
                            return null;
                        }
                    }
                    return oldItem;
                }).filter(Boolean)
            );
        }

    };

    const saveToLocalStorage = (productId, updatedQuantity, id) => {
        if (id) {

            const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
            const existingProductIndex = cartItems.findIndex(item => item.id === id);

            if (existingProductIndex >= 0) {
                cartItems[existingProductIndex].count = updatedQuantity;
            } else {
                cartItems.push({ id, count: updatedQuantity });
            }

            sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
            addToCart()
        } else {
            const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
            const existingProductIndex = cartItems.findIndex(item => item.productId === productId);

            if (existingProductIndex >= 0) {
                cartItems[existingProductIndex].count = updatedQuantity;
            } else {
                cartItems.push({ productId, count: updatedQuantity });
            }

            sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
            addToCart()
        }

    };
  const removeFromCart = async (item) => {
        try {
            let pay = {
                count: item.count,
                basketId: item.basketId,
                clientId: localStorage.getItem('clientId')
            }
            let res = await deleteFromBasket(pay)
            if(res.data.isSuccess){
                // showSuccess('محصول مورد نظر از سبد خرید حذف شد.')
                addToCart()
            }else{
                // showSuccess(res.data.message)
            }
        } catch (error) {

        }
        // const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
        // const updatedCart = cartItems.filter(item => item.productId !== productId);
        // sessionStorage.setItem('cartItems', JSON.stringify(updatedCart));
    };


    useEffect(() => {
        addToCart()
        // const productData = sessionStorage.getItem('cartItems');
        // if (productData) {
        //     setItems(JSON.parse(productData));
        //     setTotalItems(JSON.parse(productData).length)
        // }
    }, []);
    // Calculate the total price based on item quantities and prices
    const totalPrice = items.reduce((acc, item) => acc + (item.price * item.count), 0);
    const checkLogin = () => {
        if (localStorage.getItem('userData')) {
            window.location.href = '/payment'
        } else {
            setFatsLogin(true)
        }
    }


    const goToPayment = () => {
        navigate('/payment');
    };
    return (
        <>  <div ref={ref}>
            <div style={{ position: 'relative' }}>
                <button onClick={openBasket} className='d-flex align-items-center justify-content-center border-blue basket-border p-2 hover:bg-[#0033cc24] animation' style={{ width: '44px', height: '44px' }}>
                    <img src={Shop} alt="" />
                </button>
                {totalItems > 0 && <div>
                    <Badge className='number' value={totalItems} severity="danger" style={{ position: 'absolute', top: '-1em', right: '-0.5em' }}></Badge>

                </div>}

            </div>

            <Overlay
                rootClose={true}
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                onHide={closeBasket}
            >
                <Popover id="popover-contained" className='w-auto'>
                    <div className="p-2">
                        {items && items.length > 0 ? (
                            <>
                                <div className="flex justify-between p-2 border-b-[1px] border-b-[#CCD9FF] py-2 font-bold">
                                    <div className="text-[#B8B8B8] number">
                                        {items.length} محصول
                                    </div>
                                    <div>
                                        <a href="/shopping-cart" className="text-blue">رفتن به سبد خرید</a>
                                    </div>
                                </div>
                                <div style={{height: '60vh',padding: '1em' , overflow: 'auto'}}>
                                    {items.map(item => (
                                        <div key={item.productId} className='flex gap-2 items-end justify-content-between border-b-[1px] border-b-[#E5ECFF] border-dashed py-3 last:border-b-0'>
                                            <div style={{ width: '94px' }}>
                                                <div className="relative overflow-hidden rounded">
                                                    <img src={`data:image/png;base64,${item.imageBase64}`} alt="" />
                                                    {/* <img src={require('../../assets/images/design/preview-bg.png')} className='absolute inset-0 z-10 !w-full !h-full' alt="" /> */}
                                                </div>
                                            </div>
                                            <div className='flex flex-col items-start justify-between min-w-[10em]'>
                                                <div className='font-bold mb-2'>
                                                    {item.name}
                                                </div>
                                                <div className='number'>
                                                    {item.price ? item.price.toLocaleString() : 0} تومان
                                                </div>
                                            </div>
                                            <div className="px-[8px] py-1 border-[1px] border-blue flex items-center justify-between w-[6em] h-[35px] font-bold rounded">
                                                <div className='cursor-pointer' onClick={() => changeQuantity(item, 'add')}>
                                                    <img src={require('../../assets/icons/basket/add.svg').default} alt="" style={{ width: '17px' }} />
                                                </div>
                                                <div className='number'>{item.count}</div>
                                                <div className='cursor-pointer' onClick={() => changeQuantity(item, 'minus')}>
                                                    {item.count === 1 ? (
                                                        <img src={require('../../assets/icons/basket/trash.svg').default} alt="" />
                                                    ) : (
                                                        <img src={require('../../assets/icons/basket/minus.svg').default} alt="" />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="border-t-[1px] border-t-[#CCD9FF] py-2">
                                    <div className="flex justify-between items-end">
                                        <div className="flex flex-col items-start gap-1">
                                            <div className='font-bold'>
                                                قیمت قابل پرداخت :
                                            </div>
                                            <div className="font-bold text-lg number">
                                                {totalPrice.toLocaleString()} تومان
                                            </div>
                                        </div>
                                        <button className="btn btn-primary" onClick={() => checkLogin()}>نهایی سازی سفارش</button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className='dont-bold text-center'>
                                محصولی در سبد خرید شما وجود ندارد !
                            </div>
                        )}
                    </div>
                </Popover>
            </Overlay>
        </div>
            {fastLogin === true &&
                <div>
                    <FastLoginCom successAction={goToPayment} onClose={() => setFatsLogin(false)} />
                </div>}
        </>

    );
};

export default Basket;
